// src/store/reducers/signalrReducer.ts
import { ActionType } from "../action-types";
import { Action } from "../actions";
import type { SignalREvent } from "../../signalr/types";

export type SignalRState = {
  connected: boolean;
  connecting: boolean;
  error: string | null;

  lastEvent: SignalREvent | null;
  eventsByConversation: Record<string, SignalREvent[]>;
};

export const signalrInitialState: SignalRState = {
  connected: false,
  connecting: false,
  error: null,
  lastEvent: null,
  eventsByConversation: {},
};

export const signalrReducer = (
  state: SignalRState = signalrInitialState,
  action: Action
): SignalRState => {
  switch (action.type) {
    case ActionType.SIGNALR_CONNECTING:
      return { ...state, connecting: true, error: null };

    case ActionType.SIGNALR_CONNECTED:
      return { ...state, connecting: false, connected: true, error: null };

    case ActionType.SIGNALR_DISCONNECTED:
      return { ...state, connecting: false, connected: false };

    case ActionType.SIGNALR_ERROR:
      return { ...state, connecting: false, error: action.payload ?? null };

    case ActionType.SIGNALR_EVENT_RECEIVED: {
      const evt = action.payload as SignalREvent;

      if (evt.type === "OperationFailed") {
        return { ...state, lastEvent: evt };
      }

      const prev = state.eventsByConversation[evt.conversationId] ?? [];
      return {
        ...state,
        lastEvent: evt,
        eventsByConversation: {
          ...state.eventsByConversation,
          [evt.conversationId]: [...prev, evt],
        },
      };
    }

    default:
      return state;
  }
};
